import React from 'react';

import A from 'wanderu-component-react-router-link';
import {
    PageSection,
    SectionTitle,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import {
    BLOG_URL,
    CAREER_PAGE_URL,
} from '../../constants';

import aboutUsStyles from '../AboutUs/AboutUs.scss';
import styles from './CareerBlogSection.scss';

function SubSection(props) {
    const {
        label,
        title,
        description,
        buttonLabel,
        href,
        layoutClassName,
    } = props;

    return (
        <PageSection
            aria-labelledby={label}
            layoutClassName={layoutClassName}
        >
            <SectionTitle id={label}>
                {title}
            </SectionTitle>
            <p className={styles.description}>{description}</p>
            <A
                className={aboutUsStyles.aboutUsButton}
                href={href}
                native
            >
                {buttonLabel}
            </A>
        </PageSection>
    );
}

function CareerBlogSection(props) {
    const {
        t,
    } = props;

    return (
        <PageSection layoutClassName={styles.careerBlogSection}>
            <div className={styles.subSection}>
                <SubSection
                    buttonLabel={t('about-us-career-button-label')}
                    description={t('about-us-career-description')}
                    href={CAREER_PAGE_URL}
                    label="career-section"
                    layoutClassName={`${styles.careerBlogSectionLayout} ${styles.careerSection}`}
                    title={t('about-us-career-title')}
                />
            </div>
            <div className={styles.subSection}>
                <SubSection
                    buttonLabel={t('about-us-blog-button-label')}
                    className={styles.subSection}
                    description={t('about-us-blog-description')}
                    href={BLOG_URL}
                    label="blog-section"
                    layoutClassName={`${styles.careerBlogSectionLayout} ${styles.blogSection}`}
                    title={t('about-us-blog-title')}
                />
            </div>
        </PageSection>
    );
}

export {
    CareerBlogSection,
    SubSection,
};
export default localize(CareerBlogSection, ['t'], 'baseApp');
